export const CenterContainer = (props: { children: React.ReactNode }) => {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="w-full max-w-sm">{props.children}</div>
    </div>
  );
};
